'use strict';

module.exports = {
  error: 'Errore',
  required: 'Obbligatorio',
  float: 'Deve essere un numero',
  integer: 'Deve essere un intero',
  number: 'Deve essere un numero',
  lessThan: 'Deve essere inferiore a {0}',
  lessThanOrEqualTo: 'Deve essere inferiore o uguale a {0}',
  greaterThan: 'Deve essere maggiore di {0}',
  greaterThanOrEqualTo: 'Deve essere maggiore o uguale di {0}',
  between: 'Deve essere incluso tra {0} e {1}',
  size: 'La dimensione deve essere {0}',
  length: 'La lunghezza deve essere {0}',
  minLength: 'Deve avere almeno {0} caratteri',
  maxLength: 'Deve avere al massimo {0} caratteri',
  lengthBetween: 'La lunghezza deve essere tra {0} e {1}',
  in: 'Deve essere {0}',
  notIn: 'Non deve essere {0}',
  match: 'Not matched',
  regex: 'Formato non valido',
  digit: 'Deve essere una cifra',
  email: 'Email non valida',
  url: 'Url non valido',
  optionCombiner: function (options) {
    if (options.length > 2) {
      options = [options.slice(0, options.length - 1).join(', '), options[options.length - 1]];
    }
    return options.join(' o ');
  }
};
